import React, {useEffect, useRef, useState} from 'react';

import './App.css';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Form from 'react-bootstrap/Form';
import NavigationBar from "./NavigationBar";
import {Company} from "./Company";
import ImageViewer from "./ImageViewer";
import axios from "axios";
import Stack from "react-bootstrap/Stack";
import {Modal} from "react-bootstrap";
import SquareVariationSelector, {VariationEntry} from "./SquareVariationSelector";

interface GenerateAppProps {
    company: Company
    clearBackendUri: string,
    generateBackendUri: string,
    squareItemsUri: string,
    sendImageUri: string,
}

const DEFAULT_AI_TEXT: string = "Your post will appear here";
const NUM_IMAGES_MAX: number = 10;
const FB_APP_ID='338847398706566';

function GenerateApp( props: GenerateAppProps) {

/*    const loadFbLoginApi = () => {

        window.fbAsyncInit = function() {
            FB.init({
                appId      : FB_APP_ID,
                cookie     : true,  // enable cookies to allow the server to access
                // the session
                xfbml      : true,  // parse social plugins on this page
                version    : 'v2.5'
            });

            FB.getLoginStatus((response: any) => {
                if (response.authResponse) {
                    setInstagramAccess(true);
                }
                else {
                    setInstagramAccess(false);
                }
            })
        };

        console.log("Loading fb api");
        // Load the SDK asynchronously
        (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0] ;
            if (d.getElementById(id)) return;
            js = d.createElement(s) as HTMLImageElement; js.id = id;
            js.src = "//connect.facebook.net/en_US/sdk.js";
            if (fjs.parentNode) fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    }*/

    const {squareItemsUri} = props;

    const [fileList, setFileList] = useState<File[]>([]);
    const [aiText,setAiText] = useState(DEFAULT_AI_TEXT);
    const [selectedImages, setSelectedImages] = useState<Set<File>>(new Set());
    const prompt = useRef("");
    const [modalText, setModalText] = useState("");
    const [variations, setVariations] = useState<VariationEntry[]>([]);
    const [resetIdx, setResetIdx] = useState<number>(0);
    const [selectedVariations, setSelectedVariations] = useState<VariationEntry[]>([]);
    const [hideSpinner, setHideSpinner] = useState<boolean>(true);
    const [instagramAccess, setInstagramAccess] = useState<boolean>(false);

    useEffect(() => {
        axios.get(squareItemsUri).then( resp => setVariations(resp.data));
    }, [squareItemsUri]);


    /*
    useEffect(() => {
        loadFbLoginApi();
    }, []);*/

    const generate = (images: Set<File>, setAiText: (el: string) => void) => {
        setHideSpinner(false);
        const promises = Array.from(images).map(
            file => {let formData = new FormData(); formData.append('file', file); return axios.post(props.sendImageUri, formData,
        {headers: {'Content-Type': 'multipart/form-data'}})});
        Promise.all(promises)
            .then(() => axios.post(props.generateBackendUri,
                {prompt: prompt, variations: selectedVariations.map(v => v.id)}
            ))
            .then(response => {setAiText(response.data.text); setHideSpinner(true)});
    }


    const updateSelectedImages = (fl: File, selected: boolean) => {
        if (selected) {
            selectedImages.add(fl);
        } else {
            selectedImages.delete(fl);
        }
        setSelectedImages(selectedImages);
    };

    const fileUpload = (evt: React.ChangeEvent<HTMLInputElement>) => {
        const newFiles = evt.currentTarget.files;
        if (!newFiles) {
            return;
        }
        const filteredNewFiles = Array.from(newFiles).filter(file => file.type.match("(jpg|jpeg|png)$"));
        if (filteredNewFiles.length + fileList.length > NUM_IMAGES_MAX) {
            setModalText(`The maximum number of images is ${NUM_IMAGES_MAX}.`);
            return;
        }
        setFileList(fileList.concat(Array.from(filteredNewFiles)));
        filteredNewFiles.forEach(file => {selectedImages.add(file)});
        setSelectedImages(selectedImages);
    };

    const instagramLogin = () => {
        FB.login((response: any) => {
            if (response.authResponse) {
                console.log('Welcome!  Fetching your information.... ');
                FB.api('/me', {fields: 'name, email'}, (me: any) => {
                    setInstagramAccess(true);
                    //document.getElementById("profile").innerHTML = "Good to see you, " + response.name + ". i see your email address is " + response.email
                });
                return;
            }
            // If you are not logged in, the login dialog will open for you to login asking for permission to get your public profile and email -->
            console.log('User cancelled login or did not fully authorize.');
        },{scope: 'instagram_basic,pages_show_list'});
    };

    const instagramButtonClick = () => {
        if (instagramAccess) {
            // Allow to post
            return;
        }
        instagramLogin();
    }

    const clearCallback = () => {
        setFileList([]);
        setAiText(DEFAULT_AI_TEXT);
        setSelectedImages(new Set());
        setResetIdx((resetIdx + 1) % 32763);
        axios.get(props.clearBackendUri, {withCredentials: true});
    }

    const onChangePrompt = (evt: React.ChangeEvent<HTMLInputElement>) => {
        prompt.current = evt.currentTarget.value;
    };

    const squareVariationsSelector = (
        <SquareVariationSelector variations={variations} key={resetIdx} notifySelectedVariations={setSelectedVariations} />
    );

    return <div className="App">
        <Modal show={modalText.length > 0} onHide={() => setModalText("")}>
            <Modal.Header closeButton>
                <Modal.Title>Error</Modal.Title>
            </Modal.Header>
            <Modal.Body>{modalText}</Modal.Body>
        </Modal>
        <NavigationBar loggedIn={props.company !== undefined}/>
        <div className="py-5 bg-light" id="scroll-target">
        <div className="py-5 bg-light container">
            <Stack className="row" gap={3}>
                <h1>Generate</h1>
                <Form>
                    <Form.Group className="mb-3" controlId="formPrompt">
                        <Form.Label>Describe your post. Give lots of details and describe what you want to create</Form.Label>
                        <Form.Control key={resetIdx} as="textarea" rows={3} onChange={onChangePrompt} />
                    </Form.Group>
                    {squareVariationsSelector}
                </Form>
                <Stack direction={"horizontal"} gap={5}>
                <Button variant="outline-primary" onClick={() => generate(selectedImages, setAiText)}>
                    <span hidden={!hideSpinner}>Generate</span>
                    <Spinner size="sm" hidden={hideSpinner} animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                    </Spinner></Button>
                <Button onClick={clearCallback}>Clear</Button>
                </Stack>
            </Stack>
        </div>
        </div>

        <div className="py-5">
            <div className="container">
                <Stack className="row" gap={2}>
                    <div className={"img-thumbnail"}><p>{aiText}</p></div>
                    <Stack direction={"horizontal"} gap={5}>
                    <Button onClick={() => navigator.clipboard.writeText(aiText)}>Copy Text</Button>
                    </Stack>
                </Stack>
            </div>
        </div>
    </div>;
}

/*
                    <Form.Group className="mb-3" controlId="formPrompt">
                        <Form.Label>Add Images</Form.Label>
                        <Form.Control key={resetIdx} type="file" multiple onChange={fileUpload} style={{width: "50%", maxWidth: "50%"}}/>
                    </Form.Group>
                </Form>
                <ImageViewer files={fileList} notifyImageChange={updateSelectedImages} />
 */

export default GenerateApp;